import React, { ReactNode } from 'react';
import cn from 'classnames';

import styles from './ChangedField.module.scss';

interface IChangedFieldProps {
	current: ReactNode;
	fieldTitle?: string;
	isChanged?: boolean;
	previous?: ReactNode;
	prefix?: ReactNode;
	testId?: string;
}

const ChangedField = ({
	current,
	fieldTitle,
	isChanged,
	previous,
	prefix,
	testId,
}: IChangedFieldProps) => {
	return (
		<>
			{fieldTitle && <div className={styles.fieldTitle}>{fieldTitle}</div>}
			<div
				className={cn({ [styles.changedValues]: isChanged })}
				data-testid={`changed-fields-${testId}`}
			>
				{current && (
					<span data-testid='current-value'>
						{prefix}{current}
					</span>
				)}
				{previous && isChanged && (
					<span
						className={styles.previous}
						data-testid='previous-value'
					>
						{prefix}{previous}
					</span>
				)}
			</div>
		</>
	);
};

export default ChangedField;
